import React, { useEffect } from 'react';
import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';

import { RootState } from '../../../app/rootReducer';
import { AppDispatch } from '../../../app/store';
import { OverviewRow } from '../Overview';
import { clearPolicyStatus, getPolicyStatus } from './policyStatusSlice';

const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export const PolicyStatus = ({ applicationId }: { applicationId: number }) => {
  const dispatch = useDispatch<AppDispatch>();
  const policyStatus = useSelector(state => state.policyStatus);

  useEffect(() => {
    dispatch(clearPolicyStatus());
  }, [applicationId]);

  useEffect(() => {
    if (
      !policyStatus.fetchPolicyStatusInProgress &&
      !policyStatus.fetchPolicyStatusError
    ) {
      dispatch(getPolicyStatus(applicationId));
    }
  }, [applicationId]);

  return (
    <OverviewRow
      label={'Policy Status'}
      info={policyStatus.policyStatus || '-'}
    />
  );
};
